export default __webpack_public_path__ + "static/media/menu_top_duet_okara.a55ef70d.svg";